import React from "react";
import { Text13, Text2, Text3, TextTitleCard } from "./styles";
import { useApp } from "../../contexts";
import { formatMoney } from "../../utils/hepler";
import { replaceString } from "../../utils/helper";
import { UserGroup3Icon } from "../Icons/UserGroup3Icon";
import { ArrowRightCircle } from "../Icons/ArrowRightCircle";
import { isNil } from "lodash";

export const CardAffiliate3 = ({ style, data, className }) => {
  const { T, language } = useApp();

  const isNoRank = !data?.team_affiliate_rank || data?.line_rank === "no_rank";
  return (
    <div
      className={`bg-[#25292E] rounded-xl h-full px-[24px] py-[35px] ${className ? className : ''}`}
      style={style}
    >
      <div className="flex justify-between">
        <TextTitleCard>{T("My Team Affiliate Rank")}</TextTitleCard>
      </div>
      <div className="mt-4">
        <Text2>{isNoRank ? T("No line reward") : data?.line_rank}</Text2>
      </div>
      {!isNil(data?.line_need_amount) && (
        <div className="mt-2 lg:mt-6">
          <Text2
            dangerouslySetInnerHTML={{
              __html: `${replaceString(
                T("Gain {amount} and achieve milestones for next line reward"),
                ["{amount}"],
                [
                  `<span class="money">$${formatMoney(
                    +(data?.line_need_amount ?? 0),
                    0
                  )}+</span>`,
                ]
              )}`,
            }}
          />
        </div>
      )}

      <div className=" mt-9">
        <div className="flex flex-col gap-2">
          <Text2>{T("Total members")}</Text2>
          <Text13 className="flex items-center gap-3">
            {data?.downline ?? 0}
            <UserGroup3Icon />
          </Text13>
        </div>
      </div>
    </div>
  );
};
